export default "__VITE_ASSET__BubU2dAG__"